/**
 * 
 */
export default {
    install (Vue, options) {
        Vue.prototype.$toaster = (ctx, confirm) => ({
            slot: [ 
                ctx.$createElement( "div", {
                    class: {
                        "my-2": true,
                    },
                    style: {
                        display:"flex",
                        justifyContent: "center",
                    }
                }, [
                    ctx.$createElement('button', {
                        class: {
                            "v-btn theme--dark accent darken-2 ml-0 v-btn--depressed caption": true,
                        },
                        domProps: {
                            innerHTML: 'si, confirmar'
                        },
                        on: {
                            click: confirm,
                        }
                    }),
                    ctx.$createElement('button', {
                        class: {
                            "v-btn theme--dark accent darken-2 ml-2 v-btn--depressed caption": true,
                        },
                        domProps: {
                            innerHTML: 'no, cancelar'
                        },
                    }),
                ])
            ]
        })
    }
  }